import { Component } from 'react';
import Loader from '../../../../../utils/Loader';
import { ToastContainer } from 'react-toastify';
import { withRouter } from '../../../../../utils/withRouter';
import { connect } from 'react-redux';
import {
    getInternetConnectionMasterList_action,
    deleteInternetConnectionMaster_action,
    getInternetConnectionServiceItems_action,
    insertUpdateInternetConnectionServiceItems_action,
} from '../../../../../actions/admin_module_action/master_action/manual_form_master_action/internet_connection_master_action';
import { toastError, toastSuccess } from '../../../../../utils/constants';
import Modal from 'react-modal';
import HeaderWithLogo from '../../../../../common_components/header_with_logo';
import AdminDrawer from '../../../../../common_components/admin_module_drawer';
import Footer from '../../../../../common_components/Footer';

class InternetConnectionMasterList extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading:              false,
            // Service items section
            isDeleteServiceOpen:    false,
            deleteServiceIndex:     null,
            serviceList:            [],
            // Contact/bank section
            isDeleteContactOpen:    false,
            deleteContactID:        null,
            contactBankList:        [],
        };
        this.getServiceList          = this.getServiceList.bind(this);
        this.addRow                  = this.addRow.bind(this);
        this.handleChange            = this.handleChange.bind(this);
        this.onDeleteServiceClick    = this.onDeleteServiceClick.bind(this);
        this.confirmDeleteService    = this.confirmDeleteService.bind(this);
        this.saveServiceList         = this.saveServiceList.bind(this);
        this.getContactBankList      = this.getContactBankList.bind(this);
        this.onDeleteContactClick    = this.onDeleteContactClick.bind(this);
        this.confirmDeleteContact    = this.confirmDeleteContact.bind(this);
        this.handleAdd               = this.handleAdd.bind(this);
    }

    componentDidMount() {
        this.getServiceList();
        this.getContactBankList();
    }

    // ── Service Items ─────────────────────────────────────────────────────────

    getServiceList() {
        this.setState({ isLoading: true });
        this.props.getInternetConnectionServiceItems_action()
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    const list = (data.data || []).map((r) => ({
                        InternetConnectionMasterID: r.InternetConnectionMasterID,
                        ServiceItem:                r.ServiceItem,
                        InstallationCharges:        r.InstallationCharges,
                        InstallationChargesUSD:        r.InstallationChargesUSD,
                        action_id:                  2,
                    }));
                    this.setState({ serviceList: list });
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    }

    addRow() {
        const { serviceList } = this.state;
        this.setState({
            serviceList: [
                ...serviceList,
                { InternetConnectionMasterID: 0, ServiceItem: '', InstallationCharges: '', action_id: 1 },
            ],
        });
    }

    handleChange(index, field, value) {
        const updated = this.state.serviceList.map((row, i) =>
            i === index ? { ...row, [field]: value } : row
        );
        this.setState({ serviceList: updated });
    }

    onDeleteServiceClick(index) {
        const row = this.state.serviceList[index];
        if (row.InternetConnectionMasterID === 0) {
            this.setState({ serviceList: this.state.serviceList.filter((_, i) => i !== index) });
        } else {
            this.setState({ isDeleteServiceOpen: true, deleteServiceIndex: index });
        }
    }

    confirmDeleteService() {
        const { serviceList, deleteServiceIndex } = this.state;
        const updated = serviceList.map((row, i) =>
            i === deleteServiceIndex ? { ...row, action_id: 3 } : row
        );
        this.setState({ serviceList: updated, isDeleteServiceOpen: false, deleteServiceIndex: null }, () => {
            this.saveServiceList();
        });
    }

    isRowValid(row) {
        return (
            row.ServiceItem.toString().trim() !== '' &&
            row.InstallationCharges !== '' &&
            !isNaN(parseFloat(row.InstallationCharges)) &&
            parseFloat(row.InstallationCharges) >= 0
        );
    }

    saveServiceList() {
        const { serviceList } = this.state;
        const activeRows = serviceList.filter((r) => r.action_id !== 3);
        const invalidRow = activeRows.find((r) => !this.isRowValid(r));
        if (invalidRow) {
            toastError('Please fill in Service Item and a valid Installation Charge for all rows.');
            return;
        }
        this.setState({ isLoading: true });
        this.props.insertUpdateInternetConnectionServiceItems_action(serviceList)
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    toastSuccess('Service items saved successfully.');
                    this.getServiceList();
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    }

    // ── Contact / Bank Details ────────────────────────────────────────────────

    getContactBankList() {
        this.setState({ isLoading: true });
        this.props.getInternetConnectionMasterList_action()
            .then((data) => {
                this.setState({ isLoading: false });
                if (data.error != 1) {
                    this.setState({ contactBankList: data.data[0] || [] });
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    }

    onDeleteContactClick(id) {
        this.setState({ isDeleteContactOpen: true, deleteContactID: id });
    }

    confirmDeleteContact() {
        this.setState({ isLoading: true });
        this.props.deleteInternetConnectionMaster_action(this.state.deleteContactID, null)
            .then((data) => {
                this.setState({ isLoading: false, isDeleteContactOpen: false });
                if (data.error != 1) {
                    toastSuccess('Deleted successfully.');
                    setTimeout(() => this.getContactBankList(), 200);
                } else {
                    toastError(data.msg);
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ isLoading: false, isDeleteContactOpen: false });
            });
    }

    handleAdd() {
        this.props.navigate('/internetConnectionMasterAU', { state: { is_add: true } });
    }

    render() {
        const { isLoading, isDeleteServiceOpen, isDeleteContactOpen, serviceList, contactBankList } = this.state;
        const visibleRows = serviceList
            .map((row, originalIndex) => ({ row, originalIndex }))
            .filter(({ row }) => row.action_id !== 3);

        return (
            <>
                {isLoading && <Loader />}
                <ToastContainer />
                <HeaderWithLogo />

                <div className="app-content with-dr-container com-height">
                    <AdminDrawer />
                    <div className="main-container">

                        {/* Breadcrumb */}
                        <div className="row m-0">
                            <div className="breadcrumb-scroll-fixed">
                                <h6 className="mb-0 p-2 text-white">Internet Connection Master</h6>
                            </div>
                        </div>

                        <div className="admin-top-space p-2 px-0">
                            <div className="row m-0">

                                {/* ── Service Items Section ───────────────────────────────────── */}
                                <div className="card-header p-2">
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Internet Connection Service Items
                                    </h3>
                                </div>

                                <div className="table-responsive mt-1">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th className="text-center" style={{ width: 60 }}>Sr No.</th>
                                                <th className="text-center">Service Item</th>
                                                <th className="text-center" style={{ width: 220 }}>
                                                    Installation / Consumption Charges (INR)
                                                </th>
                                                <th className="text-center" style={{ width: 220 }}>
                                                    Installation / Consumption Charges (USD)
                                                </th>
                                                <th className="text-center" style={{ width: 80 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {visibleRows.length > 0 ? (
                                                visibleRows.map(({ row, originalIndex }, srNo) => (
                                                    <tr key={originalIndex}>
                                                        <td className="text-center align-middle">{srNo + 1}</td>
                                                        <td>
                                                            <input
                                                                type="text"
                                                                className="form-control"
                                                                value={row.ServiceItem}
                                                                onChange={(e) => this.handleChange(originalIndex, 'ServiceItem', e.target.value)}
                                                                placeholder="Enter service item description"
                                                                maxLength={500}
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control text-end"
                                                                value={row.InstallationCharges}
                                                                min={0}
                                                                step={0.01}
                                                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                onChange={(e) => this.handleChange(originalIndex, 'InstallationCharges', e.target.value)}
                                                                placeholder="0.00"
                                                            />
                                                        </td>
                                                        <td>
                                                            <input
                                                                type="number"
                                                                className="form-control text-end"
                                                                value={row.InstallationChargesUSD}
                                                                min={0}
                                                                step={0.01}
                                                                onKeyDown={(e) => ['e', 'E', '+', '-'].includes(e.key) && e.preventDefault()}
                                                                onChange={(e) => this.handleChange(originalIndex, 'InstallationChargesUSD', e.target.value)}
                                                                placeholder="0.00"
                                                            />
                                                        </td>
                                                        <td className="text-center align-middle">
                                                            <i
                                                                className="fa fa-trash text-danger"
                                                                style={{ cursor: 'pointer', fontSize: 16 }}
                                                                title="Delete"
                                                                onClick={() => this.onDeleteServiceClick(originalIndex)}
                                                            />
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={4} className="text-center text-muted">
                                                        No service items yet. Click <strong>+ Add</strong> to add one.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="d-flex justify-content-between mt-2 mb-4">
                                    <button type="button" className="btn btn-outline-primary btn-sm" onClick={this.addRow}>
                                        + Add
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-aqua btn-sm"
                                        onClick={this.saveServiceList}
                                        disabled={visibleRows.length === 0 && serviceList.every((r) => r.action_id !== 3)}
                                    >
                                        Save
                                    </button>
                                </div>

                                {/* ── Agency Contact and Bank Details Section ─────────────────── */}
                                <div className="card-header p-2">
                                    <h3 className="card-title" style={{ fontSize: 15 }}>
                                        Agency contact and bank details
                                    </h3>
                                </div>

                                <div className="table-responsive mt-1">
                                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0">
                                        <thead>
                                            <tr>
                                                <th className="text-center">Name</th>
                                                <th className="text-center">Designation</th>
                                                <th className="text-center">Mobile</th>
                                                <th className="text-center">Phone</th>
                                                <th className="text-center">Fax</th>
                                                <th className="text-center">Email</th>
                                                <th className="text-center">Bank Name</th>
                                                <th className="text-center">Branch / Address</th>
                                                <th className="text-center">Account Number</th>
                                                <th className="text-center">Beneficiary Name</th>
                                                <th className="text-center">Beneficiary Address</th>
                                                <th className="text-center">Swift Code</th>
                                                <th className="text-center">RTGS / IFSC</th>
                                                <th className="text-center">PAN Number</th>
                                                <th className="text-center">GST Number</th>
                                                <th className="text-center" style={{ width: 60 }}>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactBankList.length > 0 ? (
                                                contactBankList.map((data) => (
                                                    <tr key={data.InternetConnectionContactPersonID}>
                                                        <td className="text-center">{data.Name}</td>
                                                        <td className="text-center">{data.Designation}</td>
                                                        <td className="text-center">{data.Mobile}</td>
                                                        <td className="text-center">{data.Phone}</td>
                                                        <td className="text-center">{data.Fax}</td>
                                                        <td className="text-center">{data.Email}</td>
                                                        <td className="text-center">{data.BankName}</td>
                                                        <td className="text-center">{data.Address}</td>
                                                        <td className="text-center">{data.AccountNumber}</td>
                                                        <td className="text-center">{data.BeneficiaryName}</td>
                                                        <td className="text-center">{data.BeneficiaryAddress}</td>
                                                        <td className="text-center">{data.SwiftCode}</td>
                                                        <td className="text-center">{data.RTGS_IFSC}</td>
                                                        <td className="text-center">{data.PAN}</td>
                                                        <td className="text-center">{data.GST}</td>
                                                        <td className="text-center">
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-primary btn-sm border-0"
                                                                onClick={() => this.props.navigate('/internetConnectionMasterAU', { state: { editData: data } })}
                                                            >
                                                                <i className="fa fa-pencil action_btn_table" />
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-outline-danger btn-sm border-0"
                                                                onClick={() => this.onDeleteContactClick(data.InternetConnectionContactPersonID)}
                                                            >
                                                                <i className="fa fa-trash action_btn_table" />
                                                            </button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={17} className="text-center">No record found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="text-end mt-2 mb-3">
                                    <button type="button" className="btn btn-aqua" onClick={this.handleAdd}>
                                        Add
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                {/* Delete Service Item Modal */}
                <Modal isOpen={isDeleteServiceOpen} onRequestClose={() => this.setState({ isDeleteServiceOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div className="modal-header p-2">
                                <h5 className="modal-title">Do you really want to delete this service item?</h5>
                            </div>
                            <div className="modal-footer p-1">
                                <div className="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-del-pop" onClick={this.confirmDeleteService}>Yes</button>
                                    <button type="button" className="btn btn-gray" style={{ marginLeft: 5 }} onClick={() => this.setState({ isDeleteServiceOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* Delete Contact/Bank Modal */}
                <Modal isOpen={isDeleteContactOpen} onRequestClose={() => this.setState({ isDeleteContactOpen: false })}>
                    <div className="modal-dialog" style={{ marginTop: '20%' }}>
                        <div className="modal-content confirm-logout">
                            <div className="modal-header p-2">
                                <h5 className="modal-title">Do you really want to delete this record?</h5>
                            </div>
                            <div className="modal-footer p-1">
                                <div className="form-group text-right mod-fot">
                                    <button type="button" className="btn btn-del-pop" onClick={this.confirmDeleteContact}>Yes</button>
                                    <button type="button" className="btn btn-gray" style={{ marginLeft: 5 }} onClick={() => this.setState({ isDeleteContactOpen: false })}>No</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal>

                <Footer />
            </>
        );
    }
}

export default withRouter(
    connect(null, {
        getInternetConnectionMasterList_action,
        deleteInternetConnectionMaster_action,
        getInternetConnectionServiceItems_action,
        insertUpdateInternetConnectionServiceItems_action,
    })(InternetConnectionMasterList)
);
